import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { FloatButton, Popover } from 'antd';
import '../../App.css';
import { FilterOutlined } from "@ant-design/icons";
import FilterPanel from "./filterPanel";
const FloatingOptions = ({ data, extra, onClickFun }) => {
    const [clearAutoComplete, setClearAutoComplete] = useState(false); // State to clear autocomplete
    const handleClearAll = () => {
        // Clear all filters logic here
        setClearAutoComplete(true); // Trigger clearing of autocomplete
    };
    const [open, setOpen] = useState(false);
    const hide = () => {
        setOpen(false);
    };
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    return (_jsx(Popover, { trigger: "click", open: open, placement: "bottomRight", onOpenChange: handleOpenChange, content: _jsx(FilterPanel, { data: data, extra: extra, onClickFun: onClickFun }), children: _jsx(FloatButton, { icon: _jsx(FilterOutlined, {}) }) }));
};
export default FloatingOptions;
